import { render, staticRenderFns } from "./MealImageSelector.vue?vue&type=template&id=0ff98a32&scoped=true&lang=pug&"
import script from "./MealImageSelector.vue?vue&type=script&lang=js&"
export * from "./MealImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff98a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions})
